import { StyleProps, styled } from "@shared/primitive-components"

interface ExtendedStyleProps extends StyleProps {
  isOpen: boolean
  fullScreen: boolean
}

const ContentWrapper = styled.div<ExtendedStyleProps>((props) => ({
  boxSizing: `border-box`,
  display: `flex`,
  overflow: props.isOpen ? `hidden` : `auto`,
  height: props.isOpen ? `87vh` : `calc(100vh - 80px)`,
  maxHeight: `100vh`,
  padding: `16px 16px 120px`,
  flexDirection: `column`,
  position: `absolute`,
  backgroundColor: props.theme.palette.grey.lightest,
  top: 0,
  right: 0,
  width: `100%`,
  marginTop: `80px`,
  scrollbarWidth: `thin`,
  scrollbarColor: `rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05)`,
  "&::-webkit-scrollbar": {
    width: `4px`,
    backgroundColor: props.theme.palette.grey.light,
    borderRadius: `4px`,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: `rgba(0, 0, 0, 0.2)`,
    borderRadius: `4px`,
  },
  [props.theme.breakPoints.md.up]: {
    height: `100vh`,
    marginTop: 0,
    width: props.fullScreen ? `100vw` : `calc(100vw - 200px)`,
    overflowY: `auto`,
    padding: `16px 16px 60px`,
  },
}))

export default ContentWrapper
